var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsersP2P = function SvgUsersP2P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M12.5 2.5a2.917 2.917 0 0 1 0 5.833m2.5 2.924c1.732.614 3.102 1.845 3.753 3.382.449 1.06-.519 2.028-1.67 2.028M7.5 8.333a2.917 2.917 0 1 1 0-5.833 2.917 2.917 0 0 1 0 5.833m-6.075 5.929c1.047-2.022 3.373-3.429 6.075-3.429s5.029 1.407 6.076 3.429c.635 1.226-.528 2.405-1.91 2.405H3.335c-1.381 0-2.544-1.179-1.91-2.405"
  })));
};
export default SvgUsersP2P;